import React from 'react'

import PriceDetails from './PriceDetails'

import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { useCruise } from 'hooks/apiQuery/cruise'
import getValueOffPercent from 'lib/offer/getValueOffPercent'

interface Props {
  offerId: string
  depositComponent?: JSX.Element
}

function CruiseV2OfferPriceDetails({ offerId, depositComponent }: Props) {
  const { cruise } = useCruise(offerId)

  if (!cruise) {
    return null
  }

  const { total, value, cabinCategory, currencyCode } =
    cruise.mainDepartureDetails.lowestOverallPriceDetails

  if (!currencyCode) {
    return null
  }

  const priceLabel = cabinCategory ? `${cabinCategory} from` : 'From'

  let discount: number | undefined = value ?
    getValueOffPercent(value, total) :
    0
  if (discount < MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE) {
    discount = undefined
  }

  return (
    <PriceDetails
      currencyCode={currencyCode}
      price={total}
      discount={discount}
      priceLabel={priceLabel}
      depositComponent={depositComponent}
      totalLabel="/person"
    />
  )
}

export default CruiseV2OfferPriceDetails
